import { observer } from "mobx-react-lite";
import Icon from "../../DSL/Icon/Icon";
import Link from "../../DSL/Link/Link";
import { isDevModeEnabled, isStaging } from "../../environment/helpers";
import AppStore from "../../store/App.store";

interface OpenSeaLinkProps {
  pixelId: number | string;
  chain?: "ethereum" | "base";
}

const V1_PX_CONTRACT = "0x07887Ee0Bd24E774903963d50cF4Ec6a0a16977D";

function openseaBaseURL(chain: "ethereum" | "base", testnet: boolean) {
  if (testnet) {
    if (chain === "base") {
      return "https://testnets.opensea.io/assets/base-sepolia/";
    } else {
      return "https://testnets.opensea.io/assets/sepolia/";
    }
  } else {
    if (chain === "base") {
      return "https://opensea.io/assets/base/";
    } else {
      return "https://opensea.io/assets/ethereum/";
    }
  }
}

const OpenSeaLink: React.FC<OpenSeaLinkProps> = observer(({ pixelId, chain = "base" }) => {
  const baseURL = openseaBaseURL(chain, isDevModeEnabled() || isStaging());
  const contractAddress = chain === "ethereum" ? V1_PX_CONTRACT : AppStore.web3.pxContractAddress;
  return (
    <Link opacity={0.5} target={"_blank"} size={"sm"} href={baseURL + `${contractAddress}/${pixelId}`}>
      <Icon fill={"white"} icon={"openSea"} boxSize={5} />
    </Link>
  );
});

export default OpenSeaLink;
